<template>
  <!-- Main content -->
  <section class="content">
    <search-map></search-map>
  </section>
  <!-- /.content -->
</template>

<script>
import searchMapTemp from './Temp/SearchMapTemp.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    'search-map': searchMapTemp
  },
  data () {
    return {
      roleType: 99
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    let roleType = parseInt(this.getRoleType, 10)
    this.roleType = roleType
  }
}
</script>
<style lang="sass" scope>
@media screen and (max-width: 767px)
  .box-title
    text-align: center
    width: 100%
</style>



// WEBPACK FOOTER //
// SearchMap.vue?b5230a00